<div class="row justify-content-center" style="position: relative;">

  <!-- Default -->
  <div  *ngIf="siteType === 'default'" class="waveDiv" style="z-index: 0">
    <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="1920px" height="720px" viewBox="0 0 1920 720"
      version="1.1" id="SVGRoot" sodipodi:docname="wave.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)">
      <g id="layer1" inkscape:groupmode="layer" inkscape:label="Calque 1">
        <path #wave class="wave" [ngClass]="type"
          d="m 1919.2857,420 c -100.2381,-16.19048 -200.4754,-32.38082 -316.7852,-9.04759 -116.3099,23.33324 -248.6886,86.18932 -401.7853,117.61845 C 1047.6185,560 873.81153,560 686.66749,541.90473 499.52344,523.80946 299.04841,487.61919 182.39734,464.24379 65.746265,440.8684 32.919871,430.30783 0.09409144,419.74746 c 0,0 -1.52266284,-199.74746 -1.52266284,-199.74746 33.3333334,10.95238 66.6672734,21.90496 183.5721114,48.47637 116.90484,26.57141 317.38103,68.76188 504.52401,89.85704 187.14298,21.09516 360.95255,21.09516 513.89905,-13.80992 152.9465,-34.90507 285.0299,-104.71464 401.5475,-131.28567 116.5176,-26.57102 217.4692,-9.90449 318.4216,6.76218 0,0 -1.25,200 -1.25,200 z"
          id="wave" inkscape:connector-curvature="0" inkscape:path-effect="#path-effect2803"
          inkscape:original-d="m 1919.2857,420 c 0,0 -200.4752,-32.38195 -300.7143,-48.57143 C 1486.1904,434.28522 1353.8117,497.14129 1221.4286,560 1047.6185,559.999 873.81153,559.999 700,560 499.52365,523.80831 299.04862,487.61805 98.571429,451.42857 65.74665,440.8672 0.09409144,419.74746 0.09409144,419.74746 L -1.4285714,220 c 0,0 66.6676674,21.90376 100.0000004,32.85714 C 299.04862,295.04662 499.52481,337.23709 700,379.42857 c 173.81053,-10e-4 347.6201,-10e-4 521.4286,0 C 1353.5129,309.61806 1485.5963,239.80851 1617.6785,170 c 100.9534,16.66566 302.8572,50 302.8572,50 z"
          sodipodi:nodetypes="cccczcczzcccc" inkscape:label="#path2801" />
      </g>
    </svg>
  </div>

  <!-- Remi -->
  <div *ngIf="siteType === 'remi'" class="waveDiv" style="z-index: 0">
    <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="1920px" height="720px" viewBox="0 0 1920 720"
      version="1.1" id="SVGRoot" sodipodi:docname="wave.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)">
      <g id="layer1" inkscape:groupmode="layer" inkscape:label="Calque 1">
        <path #wave_remi class="wave_remi" [ngClass]="type"
          d="m 1919.2857,420 c -100.2381,-16.19048 -200.4754,-32.38082 -316.7852,-9.04759 -116.3099,23.33324 -248.6886,86.18932 -401.7853,117.61845 C 1047.6185,560 873.81153,560 686.66749,541.90473 499.52344,523.80946 299.04841,487.61919 182.39734,464.24379 65.746265,440.8684 32.919871,430.30783 0.09409144,419.74746 c 0,0 -1.52266284,-199.74746 -1.52266284,-199.74746 33.3333334,10.95238 66.6672734,21.90496 183.5721114,48.47637 116.90484,26.57141 317.38103,68.76188 504.52401,89.85704 187.14298,21.09516 360.95255,21.09516 513.89905,-13.80992 152.9465,-34.90507 285.0299,-104.71464 401.5475,-131.28567 116.5176,-26.57102 217.4692,-9.90449 318.4216,6.76218 0,0 -1.25,200 -1.25,200 z"
          id="wave_remi" inkscape:connector-curvature="0" inkscape:path-effect="#path-effect2803"
          inkscape:original-d="m 1919.2857,420 c 0,0 -200.4752,-32.38195 -300.7143,-48.57143 C 1486.1904,434.28522 1353.8117,497.14129 1221.4286,560 1047.6185,559.999 873.81153,559.999 700,560 499.52365,523.80831 299.04862,487.61805 98.571429,451.42857 65.74665,440.8672 0.09409144,419.74746 0.09409144,419.74746 L -1.4285714,220 c 0,0 66.6676674,21.90376 100.0000004,32.85714 C 299.04862,295.04662 499.52481,337.23709 700,379.42857 c 173.81053,-10e-4 347.6201,-10e-4 521.4286,0 C 1353.5129,309.61806 1485.5963,239.80851 1617.6785,170 c 100.9534,16.66566 302.8572,50 302.8572,50 z"
          sodipodi:nodetypes="cccczcczzcccc" inkscape:label="#path2801" />
      </g>
    </svg>
  </div>


  <div class="col-12 col-md-10" style="z-index: 2">
    <mat-card class="row search-book-block">
      <h1 class="titleBookk" [ngClass]="type">{{title}}</h1>

      <mat-horizontal-stepper linear #stepper class="row couleur-fond-1" >
        <ng-template  matStepperIcon="location">
          <mat-icon>location_on</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="date">
          <mat-icon>date_range</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="result">
          <mat-icon>format_list_bulleted</mat-icon>
        </ng-template>
        <mat-step  completed="false" label="{{ 'SEARCH.STEP1' | translate }}" state="location" [hasError]='true'>
          <div class="row">
            <div class="col-md-6 col-12">

              <app-search-station-input [stations]="stations" class="col-sm-12"
                [mapStationSelected]="mapStationSelected" (stationChanged)="stationChangedHandler($event)"
                (addressChanged)="addressChangeHandler($event)">
              </app-search-station-input>

              <div class="row">
                <!-- date -->
                <app-form-datepicker *ngIf="stationDetail?.detail?.type !== 7 && stationDetail?.detail?.immediate_service !== true"
                  class="col-6 col-md-12" dateLabel="{{ 'SEARCH.STARTDATE' | translate }}"
                  hourLabel="{{ 'SEARCH.HOURSTARTDATE' | translate }}" [dateValue]="departure_date">
                </app-form-datepicker>
                <app-form-datepicker color="primary" class="col-6 col-md-12" dateLabel="{{ 'SEARCH.ENDDATE' | translate }}"
                  hourLabel="{{ 'SEARCH.HOURENDDATE' | translate }}" [dateValue]="arrival_date"
                  (onApiDateChange)="CheckForm($event)">
                </app-form-datepicker>
              </div>

              <div class="col-sm-12">
                <div class="row justify-content-end">
                  <button *ngIf="!stationDetail" class="col-sm-12 align-self-end " color="primary" 
                    mat-flat-button (click)="searchBook()">{{ 'SEARCH.BOUTONSEARCH' | translate }}</button>
                  <div class="col-12 margin-block">

                    <ng-template [ngIf]="stationDetail" [ngIfElse]="elseBlock">
                      <mat-card [@rotatedState]='state'>
                        <div class="row">
                          <h3 class="col-12"><b>{{ 'SEARCH.STATIONDETAIL' | translate }}</b></h3>
                          <h4 class="col-12"><b>{{stationDetail?.detail.name }}</b></h4>
                          <ng-template [ngIf]="stationPriceText" [ngIfElse]="elseStationPriceText">
                            <div class="col-12 col-lg-6">

                              <!-- <p class="col-12 col-md-6 last"> <a id="gr" (click)="openNewTab()"><b>{{lastPosition?.latitude}},
                                {{lastPosition?.longitude}} </b></a> ({{lastPosition?.datetime | date: 'short'}}) </p> -->

                              <label class="col-12"><a id="gr" (click)="openNewTab(stationDetail?.detail.latitude, stationDetail?.detail.longitude)"><b>
                                {{stationDetail?.detail?.street}}, {{stationDetail?.detail.zipcode}} {{stationDetail.detail?.city}} </b></a>
                                </label>

                              <div *ngIf="stationDetail.detail.available; else NoAutopargeBlock">
                              </div>
                              <ng-template #NoAutopargeBlock>
                              </ng-template>

                              <label class="col-12">
                                {{stationPriceText.description_price}}</label>


                            </div>
                          </ng-template>
                          <ng-template #elseStationPriceText></ng-template>

                          <div class="col-12 col-lg-6">
                            <img class="img-fluid" [src]="_DomSanitizationService.bypassSecurityTrustUrl(img)">
                          </div>

                          <div *ngIf="stationDetail?.detail?.info_specific" class="col-12 mt-2 ml-2">
                            <div class="row">
                              <p style="font-size: small;" class="col-11 col-md-11 ml-3">
                                {{stationDetail?.detail?.info_specific}}</p>
                            </div>
                          </div>
                        </div>


                        <div class="row justify-content-center my-4">
                          <button *ngIf="stationDetail" class="col-10 col-md-11 align-self-end" color="primary"
                             mat-flat-button (click)="searchBook()">{{ 'SEARCH.BOUTONSUIVANT' | translate
                            }}</button>
                        </div>
                      </mat-card>
                    </ng-template>
                    <ng-template #elseBlock></ng-template>


                  </div>


                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 ">
              <div class="sticky-top">
                <app-leaflet-map #leafletMap [stations]="stations" (stationSelected)="stationChangedHandler($event)"
                  [currentGps]="currentGps" [zoom]='zoom'></app-leaflet-map>
              </div>
            </div>





          </div>
        </mat-step>
        <mat-step completed="false" class="col-sm-12" label="{{ 'SEARCH.STEP2' | translate }}" state="date">
          <ng-template [ngIf]="isStationDetail">
            <div *ngFor="let stationA of stationAvailabilities">
              <app-station-book-detail [stationAvailabilities]="stationA" [departureDate]="departure_date"
                [arrivalDate]="arrival_date" (stationSelect)="confirmStation($event)" [type]="type">
              </app-station-book-detail>
            </div>
          </ng-template>
          <ng-template #loading>
            <div class="row justify-content-center">
              <div class="col-4">
                <!-- <mat-icon style="width: 1=10%; height: 10%; " svgIcon="{{type}}"></mat-icon> -->
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            </div>
          </ng-template>
        </mat-step>
        <!-- <mat-step completed="false" label="{{ 'SEARCH.STEP3' | translate }}" state="result">
          <ng-template [ngIf]="_stationConfirm != null">
            <app-book-confirmation [stationAvailabilities]="_stationConfirm" [departureDate]="departure_date"
              [arrivalDate]="arrival_date"></app-book-confirmation>
          </ng-template>

        </mat-step> -->

        <mat-step completed="false" label="{{ 'SEARCH.STEP3' | translate }}" state="result">
  <ng-template [ngIf]="_stationConfirm != null" [ngIfElse]="noConfirmBlock">
    <app-book-confirmation [stationAvailabilities]="_stationConfirm" [departureDate]="departure_date"
      [arrivalDate]="arrival_date"></app-book-confirmation>
  </ng-template>
  <ng-template #noConfirmBlock>
    <div class="row justify-content-center my-4">
      <p class="col-12 text-center">Aucune réservation à confirmer pour le moment.</p>
      <button class="col-6" color="primary" mat-flat-button (click)="stepper.selectedIndex = 0">
        {{ 'SEARCH.BOUTONSEARCH' | translate }}
      </button>
    </div>
  </ng-template>
</mat-step>


      </mat-horizontal-stepper>
    </mat-card>

  </div>